import { trackGAEvent } from '@moonpig/web-core-analytics'
import { createProductItemGAEvent } from '../../../analytics'
import { ProductItemEventEnum } from '../../../types'
import { SelectProductProps } from '../types'
import { FavouriteProduct } from '../../favourites'
import { isDigitalGiftCard } from '../../../utils/isDigitalGift/isDigitalGift'

type Args = {
  pageLocation: string
  favourites: FavouriteProduct[]
}

export const createSelectProductAction =
  ({ pageLocation, favourites }: Args) =>
  (payload: SelectProductProps) => {
    const { product, list, variant, component, index } = payload
    const itemVariant = isDigitalGiftCard(product.category.department)
      ? variant.price.centAmount.toString()
      : variant.title

    const isFavourite = favourites.map(f => f.id).includes(product.id)

    const listName = list
      ? `${pageLocation} | ${list.name} | ${component} | ${list.index + 1}/${
          list.totalNumberOfLists
        }`
      : ''

    const label = list
      ? `${listName} | ${index + 1}/${list.length} | ${product.id}`
      : `${pageLocation} | ${product.id} | ${variant.key}`

    trackGAEvent(
      createProductItemGAEvent({
        eventType: ProductItemEventEnum.SELECT_ITEM,
        product: { ...product, isFavourite },
        variant: itemVariant,
        index,
        listName,
        label,
        selectedVariant: variant,
      }),
    )
  }
